import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import ProjectBlurb from '../project-blurb';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import styles from './project-desktop-image.module.css';

const DesktopAnimation = props => {
  const { isInView } = props;
  return (
    <RevealSlideDown isInView={isInView}>
      <DesktopImageContent {...props} />
    </RevealSlideDown>
  );
};

const DesktopImageContent = props => {
  const {
    desktopImage,
    backgroundColor,
    blurb,
    wrapperPadding,
    margin,
    animation,
    hideBackground,
  } = props;
  const desktopImageSizes = desktopImage.localFile.childImageSharp.sizes;
  return (
    <div style={animation}>
      {hideBackground === true ? (
        <div>
          <Img sizes={desktopImageSizes} backgroundColor={true} alt={blurb} />
        </div>
      ) : (
        <div
          className={styles.wrapper}
          style={{
            backgroundColor: `#${backgroundColor}`,
            padding: wrapperPadding,
            margin: margin,
          }}
        >
          <Img sizes={desktopImageSizes} backgroundColor={true} alt={blurb} />
        </div>
      )}
      {blurb.length !== 0 && <ProjectBlurb blurb={blurb} />}
    </div>
  );
};

const ProjectDesktopImage = props => {
  return (
    <Reveal>
      <DesktopAnimation {...props} />
    </Reveal>
  );
};

DesktopImageContent.propTypes = {
  wrapperPadding: PropTypes.string,
  blurb: PropTypes.string,
  animation: PropTypes.object,
  backgroundColor: PropTypes.string,
  desktopImage: PropTypes.object,
  hideBackground: PropTypes.bool,
};

export default ProjectDesktopImage;



// WEBPACK FOOTER //
// ./src/components/project/project-desktop-image/index.js